import React, { useState } from 'react';
import { useOnboarding } from '../../contexts/OnboardingContext';
import { Icon } from '../ui';

export default function DemoBanner() {
  const { hasDemoData, demoMode, seedDemoData, resetDemoData, startTour } = useOnboarding();
  const [seeding, setSeeding] = useState(false);
  const [seedResult, setSeedResult] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed && hasDemoData) return null;
  if (demoMode && hasDemoData) return null;

  const handleSeed = async () => {
    setSeeding(true);
    try {
      const result = await seedDemoData();
      setSeedResult({ type: 'success', message: `${result.stats.clients} clients, ${result.stats.invoices} factures, ${result.stats.payments} paiements et ${result.stats.suppliers} fournisseurs créés !` });
    } catch (err) {
      setSeedResult({ type: 'error', message: err.response?.data?.message || 'Erreur lors de la création des données' });
    } finally {
      setSeeding(false);
    }
  };

  const handleReset = async () => {
    setSeeding(true);
    try {
      await resetDemoData();
      setSeedResult(null);
    } catch (err) {
      console.error(err);
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Icon name="IconRocket" size={20} className="text-indigo-200" />
          <div>
            <span className="font-medium text-sm">
              {hasDemoData
                ? 'Mode démonstration activé'
                : 'Découvrez AccountInTime avec des données préremplies'}
            </span>
            {seedResult?.type === 'success' && (
              <span className="ml-2 text-xs text-indigo-200">{seedResult.message}</span>
            )}
            {seedResult?.type === 'error' && (
              <span className="ml-2 text-xs text-red-300">{seedResult.message}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {!hasDemoData ? (
            <button
              onClick={handleSeed}
              disabled={seeding}
              className="px-4 py-1.5 bg-white text-indigo-700 rounded-lg text-sm font-semibold hover:bg-indigo-50 transition-colors disabled:opacity-50 flex items-center gap-2"
            >
              {seeding ? (
                <>
                  <Icon name="IconLoader" size={14} className="animate-spin" />
                  Création...
                </>
              ) : (
                <>
                  <Icon name="IconDatabase" size={14} />
                  Charger les données de démo
                </>
              )}
            </button>
          ) : (
            <>
              <button
                onClick={startTour}
                className="px-4 py-1.5 bg-white text-indigo-700 rounded-lg text-sm font-semibold hover:bg-indigo-50 transition-colors"
              >
                <Icon name="IconRocket" size={14} className="mr-1" />
                Visite guidée
              </button>
              <button
                onClick={handleReset}
                disabled={seeding}
                className="px-3 py-1.5 border border-white/30 text-white rounded-lg text-sm hover:bg-white/10 transition-colors disabled:opacity-50"
              >
                Supprimer les données
              </button>
            </>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
            aria-label="Fermer"
          >
            <Icon name="IconX" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
